import { get } from './';

export const getPartnerships = () => get(`/partnerships`);
